<template>
    <div class="chk-prod-card" :class="{'disabled-card' : disabled, 'selected-card' : selected}">
        <!-- card naming conflicts with bootstrap ones O_O -->
        <div class="item-card-body" :class="cssClass.body">
            <slot name="quickAdd" :checkAppMobile="checkAppMobile" />

            <template v-if="image && url && !quickAddMode">
                <a :href="url" @click="checkAppMobile" class="img-link" v-bind="mubData">
                    <ImageTag :src="image" :alt="title" :size2x="imageSize2x" class="card-image" />
                </a>
            </template>
            <ImageTag v-if="image && (!url || quickAddMode)" :src="image" :alt="title" :size2x="imageSize2x" class="card-image" />
            <div v-if="label" v-html="label" class="label-box" :class="{'desktop-mode' : isDesktop}"></div>
            <div class="card-content">
                <span class="out-of-stock-label" :class="{'out-of-stock-climatized': climatized || isOffer }" v-if="outOfStock && (isDesktop || isOffer)"><i class="prz-info out-of-stock-icon"></i> {{outOfStock}} </span>
                <span class="not-eligible-label" :class="{'not-eligible-climatized': climatized }" v-if="notEligible" ><i class="prz-info not-eligible-icon"></i> {{notEligible}} </span>
                <h3 class="card-title" :class="{'opacity-0' : quickAddMode}">  
                    <a v-if="url" :href="url" v-html="title" @click="checkAppMobile" v-bind="mubData" />
                    <span v-else v-html="title" />
                    <span class="product-variants" v-if="productVariantTxt"> {{ productVariantTxt }}</span>
                </h3>
                <slot name="subtitle">
                    <h4 v-if="subTitle" class="card-subtitle" v-html="subTitle" />
                    <span v-if="quantity" class="subtitle__qtd">{{kStrings.kQTY + ':' }} {{quantity.toString().padStart(2, "0")}}</span>
                </slot>
                <slot />
                <div v-if="hasExtraInfo && detailedData" class="card-controls card-controls-static">
                    <div class="item-counter">
                        {{ kStrings.kQTY + ':' }} {{ detailedData.quantity.toString().padStart(2, "0") }}
                    </div>
                    <div class="item-price-info unit-price">
                        {{ detailedData.unitPrice }}
                    </div>
                    <div class="item-price-info">
                        {{ detailedData.price }}
                    </div>
                </div>
            </div>
        </div>
        <slot name="buttons"></slot>
        <slot name="footer"></slot>
    </div>
</template>

<script>

import {store} from '@/store/Checkout';
import ImageTag from '@/components/Muffin/ImageTag.vue';


export default {
    name: 'Card',
    store,
    components: {
        ImageTag
    },
    props: {
        // pass object prop
        title: {type: String, default: ''},
        url: {type: String, default: null},
        subTitle: {type: String, default: null},
        image: {type: String, default: ''},
        // image size "2x" to use in attribute srcset
        // see component "ImageTag" for possible values
        imageSize2x: {
            type: [Object, Boolean, Number], 
            default: true
        },
        label: {type: String, default: null},
        outOfStock: {type: String, default: ''},
        notEligible: {type: String, default: ''},
        disabled: {type: Boolean, default: false},
        selected: {type: Boolean, default: false},
        hasExtraInfo: {type: Boolean, default: false},
        detailedData: {type: Object, default: null},
        quantity: {type: Number, default: null},
        climatized: {type: Boolean, default: false},
        isOffer: {type: Boolean, default: false},
        variants: {type: Array, default: null},
        cssClass: {
            type: Object, 
            default: () => {
                return {
                    body: null,
                }
            }
        },
        quickAddMode: { // ex: index suggestions list
            type: Boolean,
            default: false
        },
        mubData: {type: Object, default: null},
    },
    data() {
        return {
            productVariant: null
        };
    },
    computed: {
        kStrings(){
            return this.$store.getters.kStrings;
        },
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        productVariantTxt(){
            // console.log(this.productVariant)
            if(!this.productVariant || !(this.productVariant.value ?? null)){
                return '';
            }

            return (this.productVariant.label??'') + ': ' + this.productVariant.value
        }
    },
    // watch: {},
    // beforeCreate() {},
    // created() {},
    mounted() {
        this.selectFirstVariant();
    },
    methods: {
        checkAppMobile(event){
            if(typeof App !== 'undefined' && App.js.checkAppMobile() !== ""){
                const props = {
                    url: this.url,
                    name: this.title,
                }
                App.js.callAppsJs('openModal', props);
                event.preventDefault();
            }
        },
        selectFirstVariant() {
            this.productVariant = this.variants && Array.isArray(this.variants) && this.variants.length > 0 ? this.variants[0] : null;
        }
    },
};
</script>

<style scoped>

</style>